import React from "react";

const Series = (props) => {
    // console.log('>>>>>>', props)
    const { name, genre, desc, author } = props.pageContext;
    // відсутні дані genre (жанр) та author

    // Створюємо структуру JSON-LD для серії книг
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "BookSeries",
        "name": name,
        "genre": Array.isArray(genre) ? genre : [genre],
        "description": desc
    };

    // Додаємо інформацію про автора, якщо вона є
    if (author) {
        jsonLd.author = {
            "@type": "Person",
            "name": author.name,
            ...(author.sameAs && { "sameAs": author.sameAs })
        };
    }

    return (
        <script
            className="BookSeries"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    );
};

export default Series;